import dbConnection from "../dbConnection";

const generalActions = {
  getCouncils: function () {
    return dbConnection.get("api/admin/councils");
  },
  getCouncil: function (id) {
    return dbConnection.get("api/admin/councils/" + id);
  },
  getSchool: function (id) {
    return dbConnection.get("api/admin/schools/" + id);
  },
  getFeedbacks: function () {
    return dbConnection.get("api/admin/feedbackList");
  },
  changeFeedbackStatus: function (payload) {
    return dbConnection.post("api/admin/feedback/changeStatus", payload);
  },
  getNotices: function (schoolId, params) {
    let url = "api/admin/notification/all?";
    if (schoolId) {
      url = url + "school_id=" + schoolId;
    }
    if (params.page) {
      url = url + "&page=" + params.page;
    }
    if (params.filter) {
      url = url + "&filter=" + params.filter;
    }
    return dbConnection.get(url);
  },
  getActionsHistory: function (params) {
    return dbConnection.post("api/admin/administration/actionsHistory", params);
  },
  getPendingNotices: function (params) {
    return dbConnection.get("api/admin/notification/showPendingNotices");
  },
  verfifyNotice: function (params) {
    return dbConnection.get(
      "api/admin/notification/verifyNotice/" +
      params.notice_id +
      "/" +
      params.status
    );
  },
  searchParentsChildren: function (params) {
    return dbConnection.post("api/admin/actions/searchParentsChildren", params);
  },
  sendNotifications: function (params) {
    return dbConnection.post(
      "api/admin/actions/sendNotificationsOnly/" + params.notice_id,
      params
    );
  },
  resetJourney: function (params) {
    return dbConnection.post("api/admin/actions/resetJourney", params);
  },
  resetPassword: function (params) {
    return dbConnection.post("api/admin/actions/resetPassword", params);
  },
  deleteAction: function (params) {
    return dbConnection.post("api/admin/actions/deleteAction", params);
  },
  changeStudentYear: function (params) {
    return dbConnection.post("api/admin/actions/changeStudentYear", params);
  },
  sendLoginEmails: function (params) {
    return dbConnection.post("api/admin/actions/sendLoginEmails", params); //{ school_id: vm.school_id },
  },
  sendServiceEmails: function (params) {
    return dbConnection.post("api/admin/adminTools/sendServiceEmails", params);
  },
  removeUsersSchools: function (params) {
    return dbConnection.post(
      "api/admin/actions/removeUsersSchools/" + params.school_id,
      {}
    );
  },
  getAllAdminMessages: function () {
    //sadmin
    return dbConnection.get("api/admin/adminTools/getAdminMessages");
  },
  saveAdminMessage: function (params) {
    return dbConnection.post("api/admin/adminTools/saveAdminMessage", params);
  },
  changeStudentsSchoolAndYear: function (params) {
    return dbConnection.post(
      "api/admin/actions/changeStudentsSchoolAndYear",
      params
    );
  },
  changeTravelMode: function (payload) {
    return dbConnection.post(
      "api/admin/administration/changeTravelMode",
      payload
    );
  },
  newTerm: function (params) {
    return dbConnection.post(
      "api/admin/administration/getSchoolDataAndSetNewTerms",
      params
    );
  },
  moveChildrenUpAYear: function (params) {
    return dbConnection.post(
      "api/admin/adminTools/moveChildrenUpAYear",
      params
    );
  },
  removeUserFromSchool: function (params) {
    return dbConnection.post("api/admin/actions/removeUserFromSchool", params);
  },
  removeStudentFromSchool: function (params) {
    return dbConnection.post(
      "api/admin/actions/removeStudentFromSchool",
      params
    );
  },
  removeParentsWithoutSchool: function (params) {
    return dbConnection.get("api/admin/adminTools/removeParentsWithoutSchool");
  },
  verifyNotice: function (noticeId, status) {
    return dbConnection.get(
      "api/admin/notification/verifyNotice/" + noticeId + "/" + status
    );
  },
  getHeatmapData: function (payload) {
    return dbConnection.post("api/dashboard/heatmapData", payload);
  },
  getHeatmapSimulatedData: function (payload) {
    return dbConnection.post("api/dashboard/heatmapDefaultData", payload);
  },
  getStudentMarkers: function (payload) {
    return dbConnection.post(
      "api/admin/administration/studentMarkers/",
      payload
    );
  },
  getJourney: function (payload) {
    return dbConnection.post(
      "api/admin/administration/studentJourney/",
      payload
    );
  },
  integrationAddSchoolToken: function (payload) {
    return dbConnection.post(
      "api/admin/mis_integration/integrationAddSchoolToken",
      payload
    );
  },
  integrationListSchools: function () {
    return dbConnection.get("api/admin/mis_integration/listSchools");
  },
  integrationSyncSchoolData: function (schoolId) {
    return dbConnection.get(
      "api/admin/mis_integration/syncSchoolData/" + schoolId
    );
  },
  loadWondeStats: function (schoolId) {
    return dbConnection.get(
      "api/admin/mis_integration/loadWondeStats/" + schoolId
    );
  },
  addTestUserToWonde: function (payload) {
    return dbConnection.post(
      "api/admin/mis_integration/addTestUserToWonde",
      payload
    );
  },
  removeSchool: function (data) {
    return dbConnection.post("api/admin/actions/removeSchool", data);
  },
  disableSchool: function (data) {
    return dbConnection.post("api/admin/actions/disableSchool", data);
  },
  checkMiEmail: function (data) {
    return dbConnection.post("api/admin/mis_integration/checkMiEmail", data);
  },
  getMiLogs: function (data) {
    return dbConnection.post("api/admin/mis_integration/getMiLogs", data);
  },
  excludeWondeUser: function (wondeUserId) {
    return dbConnection.post("api/admin/mis_integration/excludeWondeUser", {
      wonde_user_id: wondeUserId,
    });
  },
  getAutomationJobs: function () {
    return dbConnection.get("api/admin/automationJobs");
  },
  postAutomationJob: function (data) {
    return dbConnection.post("api/admin/automationJobs/storeJob", data);
  },
  getOrgRelationship: function (orgId) {
    return dbConnection.get("api/admin/organization/relationships/" + orgId);
  },
  postOrgRelationship: function (orgId, payload) {
    return dbConnection.post(
      "api/admin/organization/relationships/" + orgId,
      payload
    );
  },
  getOrgUsers: function (orgId) {
    return dbConnection.get("api/admin/organization/users/" + orgId);
  },
  postOrgUsers: function (orgId, payload) {
    return dbConnection.post("api/admin/organization/users/" + orgId, payload);
  },
  removeUser: function (orgId, userId) {
    return dbConnection.delete(
      "api/admin/organization/users/" + orgId + "/" + userId
    );
  },
  stapDataJourneyCount: function (form) {
    return dbConnection.post("api/admin/actions/stapDataJourneysCount", form);
  },
  postPresignedUrl: function (params) {
    return dbConnection.post('api/admin/step_datamodel/presignedUploadUrl', params);
  },
  getCsvSnapshots: function () {
    return dbConnection.get('api/admin/actions/csvSnapshots');
  },
  generateCsvSnapshot: function (tableName: string) {
    return dbConnection.post('api/admin/actions/generateCsvSnapshot', { tableName });
  },
  getSignedCsvFile: function (csvPath: string) {
    return dbConnection.post('api/admin/actions/getSignedCsvFile', { csvPath });
  },
  clearCache: function (cacheType: string) {
    return dbConnection.post('api/admin/actions/clearCache', { cacheType });
  },
};

export default generalActions;
